import React, {Component} from 'react';
import styles from './MembershipOptionView.module.css';
import {paymentConfig} from '../../../../shared/project-info/paymentConfig';
import CustomButton from '../CustomButton';
import {rwbApi} from '../../../../shared/apis/api';
import {userProfile} from '../../../../shared/models/UserProfile';
import RadioFormOptions from '../RadioFormOption';
import {withRouter} from 'react-router-dom';
import {projectConfig} from '../../../../shared/project-info/projectConfig';
import {IconButton} from '@material-ui/core';
import XIcon from '../svgs/XIcon';
export class MembershipOptionView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      optionIndex: null,
      optionData: [],
      discountRate: null,
      optionChanged: false,
      selectedOption: {},
      newAccount: this.props.location.state?.newAccount,
      optionError: '',
    };
    this.user = userProfile.getUserProfile();
    this.userAmountPaid = this.user?.latest_purchase?.amount_paid / 100 || 0;
  }

  componentDidMount = async () => {
    await rwbApi
      .getSubscriptionOptions()
      .then((res) => {
        this.setState({
          optionData: this.reformatOptions(res),
          isLoading: false,
        });
      })
      .catch((err) => {
        this.setState({isLoading: false});
        console.warn(err);
        // errorAlert(paymentConfig.membershipOptionsError);
        // this.closePressed();
      });
    if (projectConfig.membershipDiscount) {
      rwbApi
        .getDiscountRate()
        .then((res) => {
          this.setState({
            discountRate: res.rate,
            isLoading: false,
          });
        })
        .catch((err) => {
          this.setState({isLoading: false});
          console.warn(err);
          alert(paymentConfig.membershipOptionsError);
          this.closePressed();
        });
    }
  };

  reformatOptions = (options) => {
    return options.data.map((option) => {
      let newObj = {};
      newObj['id'] = option.id;
      newObj['label'] = option.description;
      newObj['value'] = option.price / 100;
      newObj['icon'] = option.logo;
      return newObj;
    });
  };
  clearErrorWarnings = () => {
    this.setState({optionError: ''});
  };

  validateInput = () => {
    const {optionData, optionIndex} = this.state;
    this.clearErrorWarnings();
    if (optionIndex === null) {
      this.setState({optionError: 'Please select an option'});
      return;
    }
    const data = {
      id: optionData[optionIndex]?.id,
      title: optionData[optionIndex]?.label,
      price: optionData[optionIndex]?.value,
      icon: optionData[optionIndex]?.icon,
    };
    this.props.history.push({
      pathname: '/paymentview',
      state: data, // Pass data via state
    });
  };
  navigateToFeed = () => {
    this.props.history.push({
      pathname: '/feed',
    });
  };
  handleBack = () => {
    this.props.history.goBack();
  };

  render() {
    const now = new Date();
    const today = new Date(now.toISOString());
    const expirationDate = new Date(this.user.latest_purchase?.expiration_date);
    const isExpiredPurchase = expirationDate < today;
    const {newAccount} = this.state;
    return (
      <div className={styles.container}>
        <div className={styles.headerContainer}>
          {!this.state.newAccount && (
            <IconButton
              onClick={() => this.handleBack()()}
              className={styles.menuButton}
              color="inherit">
              <XIcon tintColor={'var(--white)'} />
            </IconButton>
          )}
          <h3 className="title">{paymentConfig.appSettingsMembershipLabel}</h3>
        </div>
        <div className={styles.contentContainer}>
          <div className={styles.privacyPolicyContainer}>
            <p>
              {paymentConfig.joinMembershipText}

              <RadioFormOptions
                className={styles.radioForm}
                inline
                radioProps={this.state.optionData}
                label={''}
                name={'purchaseoption'}
                error={this.state.optionError}
                isCurrentMembershipTier={
                  userProfile.getUserProfile().latest_purchase?.purchase_choice
                }
                value={this.state.selectedOption}
                discount={this.userAmountPaid !== 0 && !isExpiredPurchase}
                discountRate={this.state.discountRate}
                onValueChange={(value, index) => {
                  this.setState({
                    selectedOption: value,
                    optionIndex: index,
                  });
                }}
              />
            </p>
          </div>
          <div className={styles.privacyPolicyContainer}>
            <p>
              {paymentConfig.supportingBrandsText[0].text}
              <a
                className={`link ${styles.clickable}`}
                target="_blank"
                rel="noopener"
                href={paymentConfig.supportingBrandsLink}>
                {paymentConfig.supportingBrandsLinkText}
              </a>
            </p>
          </div>
          <div className={styles.buttonContainer}>
            <CustomButton
              onClick={() => this.validateInput()}
              label="Next"
              buttonStyle="primary"
            />
            {newAccount && (
              <CustomButton
                onClick={() => this.navigateToFeed()}
                label={paymentConfig.closeButtonText}
                buttonStyle="secondary"
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(MembershipOptionView);
